import { VStack, Text } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { useStores } from "../../store/store_context";
import baseUrl from "../../vars";
import { authFetch } from "../../auth/auth";
import ReportCard from "./report_card";

const Reports = observer(() => {
  const { pageStore } = useStores();
  const [reports, setReports] = useState([]);

  const params = new URLSearchParams();

  if (pageStore.selected_managers && pageStore.selected_managers !== "") {
    pageStore.selected_managers.forEach((manager) => {
      params.append("manager", manager);
    });
  }

  const getAllReports = async () => {
    pageStore.setLoading(true);
    try {
      const response = await authFetch(
        `${baseUrl}/api/reports?start=${pageStore.start_date}&end=${pageStore.end_date}${
          pageStore.selected_managers === "" ? "" : `&${params.toString()}`
        }${
          pageStore.selected_one_department === ""
            ? ""
            : `&section=${pageStore.selected_one_department}`
        }`,
        {
          method: "GET",
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${pageStore.token}`,
            "X-Database": pageStore.select_backup != "" ? "temp": "main"
          },
        }
      );
      const result = await response.json();
      setReports(result?.data || []);
    } catch (error) {
      console.error("Error fetching reports:", error);
    } finally {
      pageStore.setLoading(false);
    }
  };

  useEffect(() => {
    getAllReports();
  }, [
    pageStore.start_date,
    pageStore.end_date,
    pageStore.selected_managers,
    pageStore.selected_one_department,
  ]);

  return (
    <VStack width={"100%"} marginTop={"20px"} padding={"0 20px"}>
      {reports?.length === 0 ? (
        <Text fontWeight={"600"} fontSize={"18px"} color={"myColor.white"}>
          Отчёты не найдены
        </Text>
      ) : (
        reports
          .sort(
            (a, b) => new Date(b?.dateCreated) - new Date(a?.dateCreated)
          )
          .map((item, index) => (
            <ReportCard item={item} index={index} key={index} />
          ))
      )}
    </VStack>
  );
});

export default Reports;
